module.exports = __webpack_public_path__ + "img/flash.87360ea5.png";